module.exports = __webpack_public_path__ + "static/media/iho-brand.d05a6cc0.svg";